import {Helmet} from "react-helmet";
import {useContext, useEffect, useState} from "react";
import {CompanyContext} from "../../lib/CompanyProvider";
export default function Meta(props) {
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [companyName, setCompanyName] = useState('');

  useEffect(()=> {
      if (companyContext?.company?.companyName) {
        setCompanyName(companyContext?.company?.companyName);
      }
  }, [companyContext]);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8"/>
        <title>{companyName?.length > 0 ? companyName : 'Play Space Brain'}
          {' - ' }
          {props?.pageTitle || ''}</title>
      </Helmet>
    </>
  );

}